module.exports = __webpack_public_path__ + "static/media/mascot_paraco.d4558e8d.png";